import { createClient } from '@supabase/supabase-js'
import { Database } from '../types/database.types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
const databaseSchema = 'devtracker' as const

if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables')
  console.warn('VITE_SUPABASE_URL:', supabaseUrl ? 'set' : 'missing')
  console.warn('VITE_SUPABASE_PUBLISHABLE_KEY:', supabaseKey ? 'set' : 'missing')
}

export const supabase = createClient<Database, typeof databaseSchema>(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    db: {
      schema: databaseSchema,
    },
    global: {
      headers: {
        'X-Client-Info': 'devtracker-web',
      },
    },
  }
)
